module.exports = __webpack_public_path__ + "img/loewe-logo.db7069b0.png";